<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import BedMapWidget from '../widgets/BedMapWidget.svelte';
  import BedSemaphoreGrid, { type SemaforoData } from '../widgets/BedSemaphoreGrid.svelte';
  import ActiveIngresosQueue from '../widgets/ActiveIngresosQueue.svelte';
  import KardexQueueWidget from '../widgets/KardexQueueWidget.svelte';
  import SignosPendientesWidget from '../widgets/SignosPendientesWidget.svelte';
  import AltasPendientesWidget from '../widgets/AltasPendientesWidget.svelte';
  import TraspasosWidget from '../widgets/TraspasosWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import KpiCard from '../widgets/KpiCard.svelte';
  import { Dashboard } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let semaforo = $state<SemaforoData | null>(null);
  let ingresosCount = $state(0);
  let kardexPend = $state(0);
  let camas = $state<any[]>([]);

  async function cargar() {
    const r = await Dashboard.resumen();
    semaforo = r.semaforo;
    ingresosCount = r.ingresosActivos;
    kardexPend = r.kardexPendientes;
    camas = r.camas;
  }

  const actions = [
    { id: 'camas', label: 'Camas', icon: '🛏️' },
    { id: 'kardex', label: 'Kárdex', icon: '💉' },
    { id: 'signos', label: 'Signos', icon: '📈' },
    { id: 'semaforo', label: 'Semáforo', icon: '🚦' },
  ];

  $effect(() => { cargar(); const t = setInterval(cargar, 30000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Unidad de cuidados" subtitle="Mapa de camas e ingresos del turno" variant="enfermeria">
  <DashHero emoji="💉" title="Unidad de cuidados" subtitle="Mapa de camas, ingresos activos y kárdex del turno" variant="enfermeria" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <KpiCard label="Ocupación" value="{semaforo?.tasaOcupacionPct ?? 0}%" tone="total" />
    <KpiCard label="Ingresos activos" value={ingresosCount} tone="brand" />
    <KpiCard label="Disponibles" value={semaforo?.porColor?.verde ?? 0} tone="success" />
    <KpiCard label="Kárdex pend." value={kardexPend} tone="warning" />
  </div>

  <div class="dash-grid">
    <div class="col-8"><BedMapWidget {camas} onCamaClick={() => onNavigate('camas')} /></div>
    <div class="col-4"><BedSemaphoreGrid data={semaforo} compact showTables={false} /></div>
    <div class="col-6"><ActiveIngresosQueue limit={12} /></div>
    <div class="col-6"><KardexQueueWidget limit={10} interactive /></div>
    <div class="col-6"><SignosPendientesWidget limit={8} {onNavigate} /></div>
    <div class="col-6"><TraspasosWidget limit={8} /></div>
    <div class="col-6"><AltasPendientesWidget limit={8} {onNavigate} /></div>
  </div>
</DashboardLayout>
